import 'url-search-params-polyfill'
import { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import {useHistory} from '../Utils/hooks'

// eslint-disable-next-line
interface PaymentContainerProps {
    setGtmIds: (chainGtmId: string) => void
}

export const PaymentContainer: FC<PaymentContainerProps> = ({ setGtmIds }) => {
    const location = useLocation()
    const history = useHistory()
    const dispatch = useDispatch()
    const query = new URLSearchParams(location.search)
    const token = query.get('token')
    const paymentState = location.pathname.replace('/payment/', '').replace('thank-you/', '')

    useEffect(() => {
        if (token) history.push(`/check-in?token=${token}&paymentState=${paymentState}`)
    }, [dispatch, paymentState, history, token])

    return null
}
